<template>
    <transition name="modal">
        <div id="addChatbotToUser" class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">
                    <span v-t="{ path: 'message.assign_chat_bot_to_stt_extension_dictionary', args: { DICT: baseDictionaryInfo.name + ' ' } }">
                    </span>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <table width="100%" height="100%" cellpadding="0" cellspacing="0">
                        <tr class="dialoginputfield">
                            <td colspan="2">
                                <div style="padding: 10px;">
                                    <!-- Radio buttons to toggle between "list-based" (all) and "search-based" -->
                                    <el-form @submit.native.prevent="handleSearch">
                                        <el-radio-group
                                            style="padding-left:10px"
                                            v-model="listType"
                                            fill="#5171cb">
                                            <el-radio-button :label="0">
                                                <span v-t="'message.action_select_by_list'"/>
                                            </el-radio-button>
                                            <el-radio-button :label="1">
                                                <span v-t="'message.action_select_by_search'"/>
                                            </el-radio-button>
                                        </el-radio-group>
                                        <!-- Shown only for listType === 1 (search) -->
                                        <el-input
                                            v-if="listType === 1"
                                            :placeholder="$t('message.place_holder_input_text')"
                                            v-model.trim="searchString"
                                            clearable
                                            class="object-search-select">
                                            <el-select
                                                v-model="condition"
                                                slot="prepend"
                                                :placeholder="$t('message.place_holder_search_condition')"
                                                class="search-item"
                                                style="width: 200px;">
                                                <el-option :label="$t('message.item_chat_bot_displayName')" value="displayName"></el-option>
                                                <el-option :label="$t('message.item_chat_bot_id')" value="objectName"></el-option>
                                            </el-select>
                                            <el-button
                                                slot="append"
                                                style="width: 100px;vertical-align:middle"
                                                native-type="submit"
                                                v-t="'message.action_search_items'"/>
                                        </el-input>
                                    </el-form>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <!-- Left side: lists of available chatbots -->
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.title_select_chatbot'">
                                        </div>
                                        <!-- “Select All” shown only in search mode, just as an example -->
                                        <div v-if="listType === 1" class="inner-panel-title-right">
                                            <button class="transparent" @click="selectTagAll()" type="button">
                                                <span class="normal-command-text" v-t="'message.action_select_all'"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!-- List-based selection (listType===0) or search results (listType===1)
                                     In both cases, we display foundChatbotList the same way. -->
                                <div class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                                    <div
                                        class="foundObject-record"
                                        v-for="chatbot in foundChatbotList"
                                        :key="chatbot.id"
                                        @click="addTagWithConditionCheck(chatbot)">
                                        <div class="foundObject">
                                            <span style="padding-left:10px;vertical-align:middle">
                                                {{ chatbot.displayName }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <!-- Right side: selected items (chatbots) -->
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.title_editing_chatbot'">
                                        </div>
                                        <div class="inner-panel-title-right">
                                            <button class="transparent" @click="removeAllUserTag()" type="button">
                                                <span class="normal-command-text" v-t="'message.action_delete_all'"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div id="selected-chatbot" class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                                    <div class="selected-item-field">
                                        <div
                                            class="default-message"
                                            v-if="!Object.keys(editTagList).length"
                                            v-html="$t('message.hint_add_chatbot')">
                                        </div>
                                        <span
                                            v-for="tag in editTagList"
                                            :key="tag.id">
                                            <div class="userTag">
                                                <span class="userTag-name">{{ tag.displayName }}</span>
                                                <span class="closeTag" @click="removeUserTag(tag)">×</span>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableSave" @click="saveUpdatedInfo()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';

// Return codes (same as in original code)
const STATUS_SUCCESS = 0;
const STATUS_ALREADY_EXIST = -1;
const STATUS_UNMATCH_DICTIONARY_ALREADY_ASSIGNED = -6;

export default {
    props: {
        tenantId: {
            type: Number,
            required: true
        },
        baseDictionaryInfo: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            scrollOnAction: false,
            // For assigned chatbots
            editTagList: {},
            orgTagList: {},
            addTagList: {},
            removeTagList: {},
            foundChatbotList: [],
            listType: 0, // 0 = list-based, 1 = search-based
            condition: "displayName",
            searchString: null,
            disableSave: true,
        };
    },

    created() {
        this.disableSave = true;
        this.getChatbotsBySttDictionary();
        this.findChatbot();
    },

    watch: {
        // Whenever user switches from "search-based" to "list-based" we load all
        listType(newVal, oldVal) {
            if (newVal === 0) {
                // If we switch back to list-based, fetch all chatbots
                this.findChatbot();
            }
        }
    },

    updated() {
        // Auto-scroll to bottom if we just added a new item
        if (this.scrollOnAction) {
            let obj = document.getElementById("selected-chatbot");
            if (obj) {
                obj.scrollTop = obj.scrollHeight;
            }
            this.scrollOnAction = false;
        }
    },

    methods: {
        handleSearch() {
            if (this.listType === 1) {
                this.findChatbot();
            }
        },

        findChatbot() {
            // Chatbot of Buddycom API is defined as the assistant whose category is 'custom' and type is 'outbound'.
            let param = { tenantId: this.tenantId, category: constants.ASSISTANT_CATEGORY_CUSTOM, type: constants.ASSISTANT_CUSTOM_BUDDY_BOT };
            if (this.condition === "objectName") {
                param.objectName = this.searchString;
            } else if (this.condition === "displayName") {
                param.displayName = this.searchString;
            }

            let loadingScreen = this.$loading({
                lock: true,
                text: 'Loading data ...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)'
            });

            let self = this;
            server.post("/findassistant", param)
                .then(res => {
                    self.foundChatbotList = [];
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (!res.data.assistantInfos || res.data.assistantInfos.length === 0) {
                                commonUtil.notifyMessage(self, "Info", commonUtil.getMessageText(self.$i18n, "info_chat_bot_not_found").replace('{object}', commonUtil.getMessageText(self.$i18n, "item_chat_bot")));
                                return;
                            }
                            for (let assistantInfo of res.data.assistantInfos) {
                                let key = self.tenantId + "-" + assistantInfo.userId;
                                let chatbotData = {
                                    id: key,
                                    tenantId: self.tenantId,
                                    type: constants.OBJECT_ASSISTANT,
                                    objectId: assistantInfo.userId,
                                    chatbotName: assistantInfo.userName,
                                    displayName: assistantInfo.displayName,
                                    label: assistantInfo.userName,
                                    dictionaryId: assistantInfo.dictionaryId
                                };
                                self.foundChatbotList.push(chatbotData);
                            }
                            break;
                        default:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","findChatbot").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch(error => {
                    self.foundChatbotList = [];
                    commonUtil.putExceptionErrorMessage(self, "findChatbot", error);
                })
                .finally(() => {
                    loadingScreen.close();
                })
        },

        getChatbotsBySttDictionary() {
            let loadingScreen = this.$loading({
                lock: true,
                text: 'Loading data ...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)'
            });

            let self = this;
            server.post('/getassistantsbysttdictionary', { dictionaryId: this.baseDictionaryInfo.id })
                .then(res => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            for (let assistantInfo of res.data.assistants) {
                                let key = self.tenantId + "-" + assistantInfo.userId;
                                let tagInfo = {
                                    id: key,
                                    tenantId: self.tenantId,
                                    type: constants.OBJECT_ASSISTANT,
                                    objectId: assistantInfo.userId,
                                    chatbotName: assistantInfo.userName,
                                    displayName: assistantInfo.displayName,
                                    label: assistantInfo.userName,
                                    dictionaryId: self.baseDictionaryInfo.id,
                                };
                                Vue.set(self.editTagList, key, tagInfo);
                                Vue.set(self.orgTagList, key, tagInfo);
                            }
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_stt_extension_dictionary_already_changed"));
                            break;
                        default:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getChatbotsBySttDictionary").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch(error => {
                    commonUtil.putExceptionErrorMessage(self, "getChatbotsBySttDictionary", error);
                })
                .finally(() => {
                    loadingScreen.close();
                });
        },

        selectTagAll() {
            let addCount = 0;
            for (let chatbot of this.foundChatbotList) {
                if (this.checkConditionToAdd(chatbot) === STATUS_SUCCESS) {
                    this.addTag(chatbot);
                    addCount++;
                }
            }
            if (addCount !== this.foundChatbotList.length) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_add_all_object").replace("{object}", commonUtil.getMessageText(this.$i18n, "item_chat_bot")));
            }
        },

        addTagWithConditionCheck(chatbot) {
            switch (this.checkConditionToAdd(chatbot)) {
                case STATUS_SUCCESS:
                    this.addTag(chatbot);
                    break;
                case STATUS_ALREADY_EXIST:
                    commonUtil.notifyMessage(this, "Info", commonUtil.getMessageText(this.$i18n,"info_chat_bot_already_added"));
                    break;
                case STATUS_UNMATCH_DICTIONARY_ALREADY_ASSIGNED:
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n,"error_cannot_add_chatbot_stt_extension_dictionary_already_assigned"));
                    break;
                default:
                    // If needed, handle other statuses
                    break;
            }
        },

        addTag(chatbot) {
            this.scrollOnAction = true;
            Vue.set(this.editTagList, chatbot.id, chatbot);
            Vue.delete(this.removeTagList, chatbot.id);
            if (!(chatbot.id in this.orgTagList)) {
                Vue.set(this.addTagList, chatbot.id, chatbot);
            }
            this.disableSave = false;
            return true;
        },

        checkConditionToAdd(tagInfo) {
            if (tagInfo.id in this.editTagList) {
                return STATUS_ALREADY_EXIST;
            }
            if (tagInfo.dictionaryId > 0 && !(tagInfo.id in this.orgTagList)) {
                return STATUS_UNMATCH_DICTIONARY_ALREADY_ASSIGNED;
            }
            return STATUS_SUCCESS;
        },

        removeUserTag(tag) {
            if (tag.id in this.orgTagList) {
                Vue.set(this.removeTagList, tag.id, tag);
            }
            Vue.delete(this.addTagList, tag.id);
            Vue.delete(this.editTagList, tag.id);
            this.disableSave = false;
        },

        removeAllUserTag() {
            for (let key in this.editTagList) {
                if (key in this.orgTagList) {
                    Vue.set(this.removeTagList, key, this.editTagList[key]);
                }
            }
            this.editTagList = {};
            this.addTagList = {};
            this.disableSave = false;
        },

        saveUpdatedInfo() {
            this.$emit('save', {removeTagList: this.removeTagList, addTagList: this.addTagList}, constants.OBJECT_ASSISTANT);
        },
    }
}
</script>

<style scoped>
.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item.selected {
    color: #5171cb;
}

</style>
